(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gtm-data-layer"] && !Shopify.designMode) return;
  try {
    /* --------------------------------------------------
   COLLECTION PAGE VIEW (collectionsPage - starts)
-------------------------------------------------- */
const buildCollectionImpressionsArray = (payload) => {
  const {products, handle} = payload;
  const builtCollectionImpressionData = [];

  products.forEach((item, index) => {
    const collectionProduct = {
      currency: currencyCode,
      class:item?.product_class,
      department:item?.product_department,
      division:item?.product_division,
      item_name: item?.title,
      item_id: item?.id?.toString(),
      item_variant: item?.variant_title,
      index: index + 1,
      item_list: window.location.pathname,
      item_category: handle,
      item_brand: item?.vendor, // @TODO add vendor to collection
      price: item?.price,
      imageURL: item?.image,
      shopify_handle: item?.handle,
      shopify_sku: item?.sku,
      shopify_product_id: item?.id?.toString(),
      shopify_variant_id: item?.shopify_variants?.nodes?.[0]?.id?.toString()
    };
    
    // end the loop by pushing the data in to the array
    builtCollectionImpressionData.push(collectionProduct);
  });


  return builtCollectionImpressionData;
};

window.GTMEventBus.subscribe(eventConstants.VIEW_COLLECTION, (payload) => {
    console.log('collectionsPage', payload);
    const {handle, products} = payload;
    const query = "";
    const collectionImpressions = buildCollectionImpressionsArray({
        handle: handle || query,
        products,
    });

    const gtmDataLayerPush = {
        event: 'collectionsPage',
        event_id: buildEventID(),
        ecommerce: {
        currencyCode,
        impressions: collectionImpressions,
        },
    };
    console.log('gtmDataLayerPush', gtmDataLayerPush);
    window.dataLayer.push(gtmDataLayerPush);
});
/* --------------------------------------------------
   COLLECTION PAGE VIEW (collectionsPage - ends)
-------------------------------------------------- */
const buildCategoryFieldFromProduct = (product) => {
  let collectionHandles = [];
  if (product?.collections) {
    if (product?.collections.hasOwnProperty('nodes')) {
      const productCollections = product?.collections?.nodes?.filter(
        (category) => category?.handle,
      );
      collectionHandles = productCollections?.map((prodCollection) => {
        return prodCollection?.title
          ? prodCollection?.title
          : prodCollection?.handle;
      });
    } else {
      collectionHandles = product?.collections;
    }
  } else {
    const productTags = product.tags;
    if (productTags?.length) {
        for (let tag of productTags) {
            var tagStr = tag;
            var tagSplit = tagStr.split('collection:');
            if (tagSplit?.length > 1) {
                collectionHandles.push(escape(tagSplit[1]));
            }
        }
    }
  }
  return collectionHandles;
};

const getProductImageURL = (product) => {
  let imageURL = '';
  if (product?.hasOwnProperty('featuredImage')) {
    imageURL = product?.featuredImage;
  } else if (product?.hasOwnProperty('image')) {
    imageURL = product?.image;
    if (imageURL && typeof imageURL === 'object' && imageURL?.hasOwnProperty('url')) {
      imageURL = imageURL?.url;
    }
  }
  return imageURL;
};

const buildProductFieldObject = (
  product,
  variant,
  handle,
  source
) => {
  const category = buildCategoryFieldFromProduct(product);
  const imageURL = getProductImageURL(product);
  const productFieldObject = {
    name: product?.title || product?.product_title,
    id: source === 'cart' ? variant?.variant_id?.toString() : product?.id?.toString(),
    productId: source === 'cart' ? product?.variant_id?.toString() : product?.id?.toString(),
    variantId: source === 'cart' ? variant?.variant_id?.toString() : variant?.id?.toString(),
    price: source === 'cart' ? product.price : 'null',
    brand: product?.vendor,
    variant: source === 'cart' ? variant?.variant_title : variant?.title,
    type: product?.product_type, // PRODUCT TYPE
    category, // CATEGORY TITLE
    imageURL,
  };

  /**
   * Not all products that come through here will have price.
   * Product remove from cart is like this currently
   */
  if (
    variant &&
    Object.prototype.hasOwnProperty.call(variant, 'priceV2') &&
    Object.prototype.hasOwnProperty.call(variant.priceV2, 'amount')
  ) {
    productFieldObject.price = variant.priceV2.amount;
  } else if (source !== 'cart' && variant?.price) {
    productFieldObject.price = (variant.price / 100).toString();
  }

  return productFieldObject;
};

const buildProductItemsFieldObject = (
  product,
  selectedVariant,
  handle,
) => {
  const item_category = buildCategoryFieldFromProduct(product);
  const imageURL = getProductImageURL(selectedVariant);
  const productItemsObject = {
    item_id: product?.id?.toString(),
    shopify_product_id: product?.id?.toString(),
    shopify_variant_id: selectedVariant?.id?.toString(),
    shopify_sku: selectedVariant?.sku,
    shopify_handle: handle,
    item_name: product?.title,
    currency: currencyCode,
    item_brand: product?.vendor,
    item_variant: selectedVariant?.title, // physical store only location_id: "",
    price: 'null',
    item_category,
    imageURL,
    class: product?.metafields?.find(val => val?.key==='product_class')?.value,
    department: product?.metafields?.find(val => val?.key==='product_department')?.value,
    division: product?.metafields?.find(val => val?.key==='product_division')?.value,
  };
  
  /**
   * Not all products that come through here will have price.
   * Product remove from cart is like this currently
   */
  if (selectedVariant?.priceV2?.amount) {
    productItemsObject.price = selectedVariant.priceV2.amount;
  } else if (selectedVariant?.price) {
    productItemsObject.price = (selectedVariant.price / 100).toString();
  }

  return productItemsObject;
};

window.GTMEventBus.subscribe(eventConstants.SELECT_ITEM, function(payload) {
    console.log('bva_select_item', payload);
    const {product, handle} = payload;

    const productFieldObject = buildProductFieldObject(
        product,
        product?.shopify_variants?.['nodes']?.[0],
        product.handle,
    );

    const productItemObject = buildProductItemsFieldObject(
        product,
        product?.shopify_variants?.['nodes']?.[0],
        product.handle,
    );

    const gtmGA4DataLayerPush = {
        event: 'bva_select_item',
        event_id: buildEventID(),
        ecommerce: {
        currencyCode,
        click: {
            actionField: {
            list: handle,
            location: window.location.href,
            },
            products: [productFieldObject],
        },
        items: [productItemObject],
        },
    };
    console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
    window.dataLayer.push(gtmGA4DataLayerPush);
});

window.GTMEventBus.subscribe(eventConstants.QUICK_VIEW, (payload) => {
    console.log('quick_view', payload);
    
    const {productTitle, productPrice, productImage} = payload;
    
    const gtmGA4DataLayerPush = {
        event: 'quick_view',
        event_id: buildEventID(),
        quickViewItem: [{
            price: productPrice? productPrice.toString() : '0',
            product_name: productTitle,
            src: productImage
        }],
    };
    console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
    window.dataLayer.push(gtmGA4DataLayerPush);
});

window.GTMEventBus.subscribe(eventConstants.VIEW_ITEM, (payload) => {
    console.log('view_item', payload);
    
    const {selectedVariant, product} = payload;

    const productFieldObject = buildProductFieldObject(
        product,
        selectedVariant,
        product?.handle,
    );
    const productItemObject = buildProductItemsFieldObject(
        product,
        selectedVariant,
        product?.handle,
    );

    const actionFieldList = 'product';

    const gtmGA4DataLayerPush = {
        event: 'bva_view_item',
        event_id: buildEventID(),
        ecommerce: {
        currencyCode,
        detail: {
            actionField: {
            list: actionFieldList,
            },
            products: [productFieldObject],
        },
        items: [productItemObject],
        },
    };
    console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
    window.dataLayer.push(gtmGA4DataLayerPush);
});

window.GTMEventBus.subscribe(eventConstants.ADD_TO_CART, function(payload) {
    console.log('bva_add_to_cart', payload);
    const {product, selectedVariant, source} = payload;
    // const pageType = collectionId ? 'collection' : 'search';

    if (product) {
        let productItemObject = source !== 'cart' ? 
            buildProductItemsFieldObject(
                product,
                selectedVariant,
                product.handle,
            ) : buildCartItemsArray(selectedVariant, payload.currency)?.[0];

        const productFieldObject = buildProductFieldObject(
            product,
            source === 'cart' ? product : selectedVariant,
            product?.handle,
            source
        );
        
        if (!productItemObject?.quantity) {
            productItemObject['quantity'] = 1;
        }
        const gtmGA4DataLayerPush = {
            event: 'bva_add_to_cart',
            event_id: buildEventID(),
            ecommerce: {
                currencyCode,
                add: {
                    actionField: {
                        list: gtmPageType,
                        location: window.location.href,
                    },
                    products: [productFieldObject],
                },
                items: [productItemObject],
            },
        };
        console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
        window.dataLayer.push(gtmGA4DataLayerPush);
    }
});

document.addEventListener('addItemToCartEvent', (event) => {
    console.log('addItemToCartEvent', event);
    const { line, quantity, cart} = event.detail;
    if (cart?.items_added?.length) {
        window.GTMEventBus.publish(eventConstants.ADD_TO_CART, {product: cart?.items_added[0], selectedVariant: cart?.items_added, source: 'cart', currency: cart.currency});
    } else if (cart?.items_removed?.length) {
        window.GTMEventBus.publish(eventConstants.REMOVE_CART_ITEM, {lines: cart?.items_removed, source: 'cart', currency: cart.currency});
    }
})

window.GTMEventBus.subscribe(eventConstants.REMOVE_CART_ITEM, function(payload) {
    console.log('bva_remove_from_cart', payload);
    const {lines, source} = payload;
    // const pageType = collectionId ? 'collection' : 'search';
    
    if (lines && lines.length) {
        let productItemObject = buildCartItemsArray(lines, payload.currency);

        const productFieldObject = buildProductFieldObject(
            lines[0],
            lines[0],
            lines[0]?.handle,
            source
        );

        const gtmGA4DataLayerPush = {
            event: 'bva_remove_from_cart',
            event_id: buildEventID(),
            ecommerce: {
            currencyCode,
            remove: {
                actionField: {
                    list: gtmPageType,
                    location: window.location.href,
                },
                products: [productFieldObject],
            },
            items: productItemObject,
            },
        };
        console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
        window.dataLayer.push(gtmGA4DataLayerPush);
    }
});

const buildCartItemsArray = (lineItemData, currencyCode) => {
  const cartItemsArray = [];
  if (lineItemData && lineItemData.length) {
    let cartLineItem;
    lineItemData.forEach((item) => {
      /* let variant_title = '';  
      const options_with_values = item.options_with_values;
      options_with_values.forEach(option => {
        if (option.name === 'size') {
            if (variant_title) variant_title += ' / ';
            variant_title += option.value;
        } else if (option.name === 'color') {
            const colorNameFamilyArr = option.value.split(' - ');
            if (variant_title) variant_title += ' / ';
            if (colorNameFamilyArr.length > 1) {
                variant_title += colorNameFamilyArr[1];    
            } else {
                variant_title += option.value;
            }
        }
      }) */  
      let handle;
      if (item?.handle) {
         handle = item?.handle;
      } else {
        const handleWithParam = item?.url?.replace('/products/', '');
        const handleParts = item?.url?.replace('/products/', '').split('?');
        if (handleParts?.length) {
            handle = handleParts?.[0];
        }
      }
      cartLineItem = {
        class: '',
        department: '',
        division: '',
        item_id: item?.product_id?.toString(),
        shopify_product_id: item?.product_id?.toString(),
        shopify_variant_id: item?.variant_id?.toString(),
        shopify_sku: item?.sku,
        shopify_handle: handle,
        item_name: item?.product_title,
        currency: currencyCode,
        item_brand: item?.vendor,
        item_category: '',
        item_variant: item?.variant_title,
        price: item?.final_price ? (item?.final_price / 100).toString() : item?.price,
        quantity: item?.quantity,
      };

      // end the loop by pushing the data in to the array
      cartItemsArray.push(cartLineItem);
     // console.log("lineItemData-", lineItemData);
    });
  }
  return cartItemsArray;
};

window.GTMEventBus.subscribe(eventConstants.VIEW_CART, function(payload) {
    console.log('bva_view_cart', payload);
    const { cart } = payload;
    const { items, total_price, currency } = cart;
    const cartItemsArray = buildCartItemsArray(items, currency);

    const gtmGA4DataLayerPush = {
        event: 'bva_view_cart',
        event_id: buildEventID(),
        ecommerce: {
            currencyCode: currency,
            value: (total_price / 100).toString(),
            items: cartItemsArray,
        },
    };
    console.log('gtmGA4DataLayerPush', gtmGA4DataLayerPush);
    window.dataLayer.push(gtmGA4DataLayerPush);
});

// Email Sign Up
document.addEventListener("submit", function(e){
  if(e.target.matches("form[action*='contact'], form[action*='newsletter']")){
    dataLayer.push({event: "email_sign"});
  }
});
  } catch(e) { console.error(e); }
})();

})();
